import { Icons } from '@agro-club/agroclub-shared'
import { formatBool } from 'helpers/formatBool'
import { t } from 'i18next'
import { DASH } from 'modules/constants'
import formatNumber from 'modules/utils/numbers/formatNumber'
import formatPrice from 'modules/utils/numbers/formatPrice'
import { DateFormatted } from '../DateFormatted'

export const priority = (priority: number) => {
  switch (priority) {
    case 1:
      return <Icons.IconHighPrior />
    case 2:
      return <Icons.IconMediumPrior />
    case 3:
      return <Icons.IconLowPrior />
    default:
      return priority
  }
}

export const integer = (number: number) => formatNumber(number)
export const decimal = (number: number) => formatNumber(number, true)

export const price = (price) => {
  return price ? formatPrice(price) : DASH
}

export const haveOrNot = (value?: boolean) => formatBool(value, t('common:thereIs'))
export const YesNo = (value?: boolean) => formatBool(value)

export const date = (date) => (date ? <DateFormatted date={date} /> : DASH)

export const CellRenders = {
  priority,
  integer,
  decimal,
  price,
  haveOrNot,
  YesNo,
  date,
}
